var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 14.168V18.418M24.082 14.168H28.332H24.082ZM32.582 14.168H28.332H32.582ZM28.332 14.168V9.91797V14.168Z",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41797 28.3333V26.9167C1.41797 21.4398 5.85782 17 11.3346 17C16.8115 17 21.2513 21.4398 21.2513 26.9167V28.3333",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 17.0013C14.4642 17.0013 17.0013 14.4642 17.0013 11.3346C17.0013 8.20502 14.4642 5.66797 11.3346 5.66797C8.20502 5.66797 5.66797 8.20502 5.66797 11.3346C5.66797 14.4642 8.20502 17.0013 11.3346 17.0013Z",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.f36ee91f2c26933f42d54dba7d4e168d.svg";
export { ForwardRef as ReactComponent };